import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://smyieaahxqigerhlnhfr.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNteWllYWFoeHFpZ2VyaGxuaGZyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYyMDI0OTYsImV4cCI6MjA3MTc3ODQ5Nn0.9v4piLtjfqU4w9V2v53MlUMoKlQJY8cNozvTX1nCFtM'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase environment variables')
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})